import React from "react";

export default function SimpleSection(props){
    const {className,children,backgroundimage} = props;
    return <section className={"c-simple-section "+((undefined!=className)?className:"")} style={
        (undefined!=backgroundimage)?
            {backgroundImage:"url("+backgroundimage+")"}:{}}>
        
        {children}
    </section>
}